import { useMemo } from 'react'

import {
  getIsScenarioNameValid,
  getScenarioNameErrorMessage
} from './textValidations'

const useOnEditValidator = (
  scenarioName: string,
  existingNames: string[],
  originalScenarioName: string,
  isScenarioNameEmpty: boolean
): [boolean, string] => {
  return useMemo(() => {
    const isUniqueScenario = !existingNames?.some(
      (scenarioOption) => scenarioName === scenarioOption
    )

    const isSameScenario = originalScenarioName === scenarioName

    const isUniqueOrSameScenario = isUniqueScenario || isSameScenario

    let isScenarioNameValid = getIsScenarioNameValid(
      scenarioName,
      isUniqueOrSameScenario
    )

    const scenarioNameErrorMessage = getScenarioNameErrorMessage(
      scenarioName,
      isScenarioNameEmpty,
      isUniqueOrSameScenario
    )

    isScenarioNameValid = isScenarioNameValid && !isScenarioNameEmpty

    return [isScenarioNameValid, scenarioNameErrorMessage]
  }, [existingNames, isScenarioNameEmpty, originalScenarioName, scenarioName])
}

export { useOnEditValidator }
